import { frontendURL } from '../../../helper/URLHelper';
import RentFlowsIndex from '../laisTenantsRentFlows/pages/RentFlowsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/negociacao'),
    component: RentFlowsIndex,
  },
];
